export default __webpack_public_path__ + "static/media/business-model-navigator.d5e9d5b6.svg";